(($) => {

    // Slider
    /*
    $('.js-slider').slick({
        accessibility: false,
        slidesToScroll: 1,
        draggable: true,
        dots: true,
        arrows: true,
        fade: false,
        speed: 800,
        infinite: false,
        appendArrows: '.slider__arrows'
    })
    */

    // Tests slider
    /*
    $('.js-tests-slider').slick({
        accessibility: false,
        slidesToShow: 1,
        variableWidth: true,
        centerMode: false,
        dots: false,
        arrows: true,
        infinite: false,
        swipe: true,
        lazyLoad: 'progressive'
    })
    */

    // Features slider
    $('.js-features-slider').slick({
        accessibility: false,
        slidesToShow: 1,
        dots: true,
        arrows: false,
        infinite: false,
        swipe: true,
        adaptiveHeight: true
    })

    // Post slider
    /*
    $('.js-post-slider').slick({
        accessibility: false,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        dots: true,
        arrows: false,
        lazyLoad: 'progressive',
        adaptiveHeight: true
    })
    */

    // Blog slider
    /*
    $('.js-blog-slider').slick({
        accessibility: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        draggable: true,
        dots: true,
        arrows: true,
        fade: false,
        speed: 800,
        infinite: false,
        responsive: [{
            breakpoint: 568,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    })
    */

    $('.js-list-items').slick({
        accessibility: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: true,
        dots: true,
        arrows: true,
        fade: false,
        speed: 800,
        infinite: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    })

})(jQuery)